import { useTranslation } from 'react-i18next';
import type { SharedPhoto } from '../../types';
import { tripPhotoUrl } from '../../utils/tripPhotos';
import { EmptyNote } from './shared.ui';

/**
 * The trip's album.
 *
 * These URLs point at an UNSIGNED public bucket, which is why PHOTOS is off by
 * default and why the share popover says out loud that switching it back off
 * does not revoke a URL somebody already copied.
 */
export default function SharedPhotos({ photos }: { photos: SharedPhoto[] }) {
  const { t } = useTranslation();

  if (photos.length === 0) return <EmptyNote>{t('shared.noPhotos')}</EmptyNote>;

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2">
      {photos.map(p => (
        <a
          key={p.id}
          href={tripPhotoUrl(p.filename)}
          target="_blank"
          rel="noopener noreferrer"
          className="block aspect-square rounded-xl overflow-hidden bg-slate-100 dark:bg-slate-800"
        >
          <img
            src={tripPhotoUrl(p.thumbnailFilename ?? p.filename)}
            alt=""
            loading="lazy"
            className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
          />
        </a>
      ))}
    </div>
  );
}
